import React, {useState} from 'react';
import {Container, Row, Col} from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import {logOut} from './redux/actions';

const SideNav = ({isLoggedIn, setIsLoginModalVisible, setIsJoinModalVisible}) => {
  const navigate = useNavigate();

  const[type, setType] = useState('')

  const onLogOut = () => {
    firebase.auth().signOut();
    firebase.auth().signOut();
    logOut();
  } 

  const changeType = (event) => {
    setType(event.target.value)
  }
  const search = (event) => {
    navigate('/search', {state:{text: type}});
    event.preventDefault()
  }
  return (
    <div className='side-nav'>
      <div className='side-nav-search-div'>
        <Container fluid className='side-nav-container'>
          <form onSubmit={search}>
            <Row>
              <Col xs={12} sm={12} md={9} lg={10} className='side-nav-input-col'>
                <input placeholder='Tacos, Chef Lanez, Bistros, Culinary School, Utensils' className='header-input header-type-input side-nav-type-input' value={type} onChange={changeType}></input>
              </Col>
              <Col xs={12} sm={12} md={3} lg={2}>
                <button className='header-search-button side-nav-search-button' style={{float: 'right', width: '100%'}} type='submit' name='submit'>Search</button>
              </Col>
            </Row>
          </form>
        </Container>
      </div>
      <div className='side-nav-body-div'>
        {!isLoggedIn ? 
        <div>
          <p><Link to='/' onClick={() => setIsJoinModalVisible(true)} className='log-out-link'>Sign Up</Link></p>
          <p><Link to='/' onClick={() => setIsLoginModalVisible(true)} className='log-out-link'>Log In</Link></p>
        </div> :
         null
        }
        {isLoggedIn ? <p><Link to='/account/settings'  className='log-out-link'>Settings</Link></p> : null}
        {isLoggedIn ? <p><Link to='/' onClick={() => onLogOut()} className='log-out-link'>Log Out</Link></p> : null}
      </div>
    </div>
  )
}

export default SideNav